const routes = [
  {
    name: 'aml',
    path: 'aml',
    redirect: { name: 'aml-rules-settings' },
    meta: { requiredPrivileges: ['System Settings'] },
    component: () => import('@/modules/global-settings/aml/layout/AMLSettingLayout.vue'),
    children: [
      {
        path: 'rules-settings',
        name: 'aml-rules-settings',
        component: () => import('@/modules/global-settings/aml/views/AmlRules.vue'),
      },
      {
        path: 'suspicious-behaviours-settings',
        name: 'aml-suspicious-behaviours',
        component: () => import('@/modules/global-settings/aml/views/SuspiciousBehaviours.vue'),
      },
      {
        path: 'transaction-monitoring-cycle-settings',
        name: 'aml-transaction-monitoring-cycle-settings',
        component: () => import('@/modules/global-settings/aml/views/TransactionMonitoringCycle.vue'),
      },
      {
        path: 'transaction-methods-settings',
        name: 'aml-transaction-methods-settings',
        component: () => import('@/modules/global-settings/aml/views/TransactionMethods.vue'),
      },
      {
        path: 'kyc-risk-levels-settings',
        name: 'aml-kyc-risk-levels-settings',
        component: () => import('@/modules/global-settings/aml/views/KYCRiskLevels.vue'),
      },
      {
        path: 'trend-settings',
        name: 'aml-trend-settings',
        component: () => import('@/modules/global-settings/aml/views/GlobalTrends.vue'),
      }
    ],
  },
];

export default routes;